import React, { useState } from "react";
import * as Cookies from "es-cookie";
import { Container } from "react-bootstrap";
import { isBrowser } from "react-device-detect";
import NavbarOne from "./neetjee_guru/components/navbars/NavbarOne";
import SideNavbar, {
  buildModuleVisibility,
  hasNoAccessibleModules,
} from "./neetjee_guru/components/navbars/SideNavbar";
import Footer from "./neetjee_guru/components/footer/Footer";

// Re-exported so App.js can send a user with zero granted modules straight to the
// Access Denied page instead of an empty app shell.
export { hasNoAccessibleModules };

// URL-level module access guard.
// The sidebar hides links a user isn't granted, but a user who knows a URL could
// still navigate there directly. This maps each protected route to the module
// key(s) that grant it, mirroring the SideNavbar gates. A route is allowed when
// ANY of its keys is granted (moduleRestrictions[key] === false, the app's
// "accessible" convention). Routes not listed here are unguarded.
//
// ORDER MATTERS: getFirstAccessibleRoute() walks this list top-to-bottom to pick the
// user's landing page after login, so it is kept in sidebar order. Dashboard is first,
// which means a user who HAS Dashboard access still lands there exactly as before.
export const MODULE_ROUTES = [
  { path: "/lecture-dashboard", keys: ["Lecture_Dashboard", "Dashboard"] },
  // Dashboard was previously absent from this table, so /dashboard was unguarded —
  // any logged-in user could open it regardless of their grant. Listing it closes
  // that hole and makes it the first landing candidate.
  { path: "/dashboard", keys: ["Dashboard"] },
  { path: "/management-mis-reports", keys: ["Management_Report"] },
  { path: "/omr-results", keys: ["OMR_Results"] },
  { path: "/omr-upload", keys: ["OMR_Results"] },
  { path: "/student-doubts", keys: ["Student_Doubts"] },
  { path: "/grievance-module", keys: ["Grievance_Management"] },

  { path: "/exam_made_easy", keys: ["Exam_Made_Easy"] },
  { path: "/questions/manage-question-paper", keys: ["Manage_Exams"] },
  { path: "/quiz_section", keys: ["Quiz"] },
  { path: "/ExamReport_tabs", keys: ["View_Results"] },
  { path: "/settings/overall-college-report", keys: ["View_Results"] },

  { path: "/offline_exams/omr", keys: ["OMR_Results"] },
  { path: "/offline_exams/exam_made_easy", keys: ["Exam_Made_Easy"] },
  { path: "/offline_exams/manage-question-paper", keys: ["Manage_Exams"] },
  { path: "/offline_exams/ExamReport", keys: ["View_Results"] },

  { path: "/admissions-dashboard", keys: ["admission_dashboard", "admission_form", "admission_form_list", "Enquiry_management", "Lead_management"] },
  { path: "/admission-forms", keys: ["admission_form"] },
  { path: "/create-admission-form", keys: ["admission_form"] },
  { path: "/student-admission-list", keys: ["admission_form_list"] },
  { path: "/enquiry-links", keys: ["Enquiry_management"] },
  { path: "/message-center", keys: ["Lead_management"] },
  { path: "/lead-management", keys: ["Lead_management"] },

  { path: "/attendance-regularization", keys: ["Student_Attendance", "Student_Attendance_report", "Biometric_Attendance"] },
  { path: "/Employee_Attendance_Report", keys: ["Student_Attendance"] },
  { path: "/hostel/attendance-report", keys: ["Hostel_Attendance", "Hostel_Attendance_Report"] },

  { path: "/student/marks-upload", keys: ["offline_marks_uploading"] },
  { path: "/student/offline-exam-results", keys: ["offline_marks_Results"] },

  { path: "/student-permission", keys: ["Permissions"] },
  { path: "/Student_Gate_Pass", keys: ["Permission_pass"] },
  { path: "/inst_revision_material", keys: ["Custom_Materials"] },
  { path: "/material-assigning", keys: ["Material_Allocation"] },

  { path: "/Offline_Examiantions", keys: ["Offline_Examiantions"] },
  { path: "/Fee-Structure", keys: ["Fee_Structure"] },
  { path: "/expense-management", keys: ["expense_management"] },
  { path: "/accounts", keys: ["Accounts_Ledger"] },
  { path: "/transport-management", keys: ["Transport_Management"] },
  { path: "/school-activity-management", keys: ["School_Activity_Management"] },
  { path: "/communication-management", keys: ["communication_management"] },
  { path: "/lecture-library", keys: ["Lecture_Library"] },
  { path: "/document-services", keys: ["Document_Services"] },
  { path: "/Certificate-Generation", keys: ["Certificate_Generation", "Certificate"] },
  { path: "/timetable-builder", keys: ["timetable_builder"] },
  { path: "/academic-planner", keys: ["academic_planner", "timetable_builder"] },
  { path: "/student-diary", keys: ["Diary"] },
  { path: "/assignment", keys: ["Assignments"] },
  { path: "/Parent_Notification", keys: ["parent_notifications"] },
  { path: "/settings/notify-students", keys: ["Send_notifications"] },
  { path: "/building-creation", keys: ["Hostel_Buildings"] },

  { path: "/settings/students", keys: ["academic_students"] },
  { path: "/settings/non-academic-students", keys: ["non_academic_students"] },
  { path: "/settings/employee-restrictions", keys: ["Employee_Restrctions"] },
  { path: "/settings/staff", keys: ["Employee_Restrctions"] },
  { path: "/settings/roles", keys: ["Employee_Restrctions"] },
  { path: "/settings/module-access", keys: ["Employee_Restrctions"] },
  { path: "/settings/branches", keys: ["branches"] },
  { path: "/settings/branch-classes", keys: ["branches"] },
  { path: "/settings/sections", keys: ["sections"] },
  { path: "/settings/organization-profile", keys: ["organization_profile"] },
];

// ── OLD CODE (kept for reference / rollback) ────────────────────────────────
// Read the legacy moduleRestrictions blob. This drifted from the sidebar the moment
// the sidebar started deriving visibility from roleModuleAccess: a module hidden in
// the menu was still reachable by typing its URL.
//
// const readModuleRestrictions = () => {
//   try {
//     const raw = localStorage.getItem("moduleRestrictions");
//     if (raw && raw !== "" && raw !== "undefined") return JSON.parse(raw) || {};
//   } catch (e) { /* ignore */ }
//   return {};
// };

// ── NEW CODE ────────────────────────────────────────────────────────────────
// Use the SAME visibility map the sidebar renders from (built from is_view grants),
// so the menu and the URL guard can never disagree about what a user may open.
const readModuleRestrictions = () => buildModuleVisibility();

// Returns the most specific (longest-prefix) guarded route for a path, or null.
const matchRoute = (pathname) => {
  let match = null;
  for (const r of MODULE_ROUTES) {
    if (pathname === r.path || pathname.startsWith(r.path + "/")) {
      if (!match || r.path.length > match.path.length) match = r;
    }
  }
  return match;
};

export const isLecturerRole = () => {
  const empRoleId = String(Cookies.get("employee_role_id") || "");
  return empRoleId === "13" || empRoleId === "35";
};

// true = allowed to view this path.
export const hasModuleAccess = (pathname) => {
  if (pathname === "/lecture-dashboard" || pathname.startsWith("/lecture-dashboard/")) {
    return isLecturerRole();
  }

  // Institute admins / management (employee_type 1 & 2) have full access.
  const userlevel = String(Cookies.get("userlevel") || "");
  if (userlevel === "1" || userlevel === "2") return true;

  const match = matchRoute(pathname);
  if (!match) return true; // route isn't module-guarded

  const moduleRestrictions = readModuleRestrictions();
  return match.keys.some((k) => moduleRestrictions[k] === false);
};

// ─────────────────────────────────────────────────────────────────────────────
// Where should this user land after logging in?
// ─────────────────────────────────────────────────────────────────────────────
export const getFirstAccessibleRoute = () => {
  if (isLecturerRole()) {
    return "/lecture-dashboard";
  }

  // Admins keep the Dashboard as their landing page — they can see everything.
  const userlevel = String(Cookies.get("userlevel") || "");
  if (userlevel === "1" || userlevel === "2") return "/dashboard";

  const moduleRestrictions = readModuleRestrictions();
  const first = MODULE_ROUTES.find((r) =>
    r.keys.some((k) => moduleRestrictions[k] === false)
  );

  return first ? first.path : "/dashboard";
};

// "No access" message shown when a user opens a URL they aren't granted.
// Rendered inside the normal app layout (top navbar + sidebar) so they can still
// navigate to modules they DO have; the message card sits centered in the content.
export const AccessDenied = () => {
  const [toggled, setToggled] = useState(Cookies.get("toggle") || "wrapper");
  const menuToggler = () => {
    const next = toggled === "wrapper" ? "wrapper sidebar-enable" : "wrapper";
    Cookies.set("toggle", next);
    setToggled(next);
  };

  return (
    <div className={toggled}>
      <div className="header-area">
        <NavbarOne onClick={menuToggler} />
      </div>
      <div className="main-wrapper">
        <div id="sidebar" className={isBrowser ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
          <SideNavbar onClick={menuToggler} />
        </div>
        <div className="student-overlay" onClick={menuToggler} />
        <div className="content-wrapper pt-0">
          <Container fluid>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "78vh", padding: 24 }}>
              <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.06)", padding: "40px 44px", maxWidth: 460, textAlign: "center" }}>
                <div style={{ width: 72, height: 72, borderRadius: "50%", background: "#fef2f2", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
                  <i className="fal fa-lock-alt" style={{ fontSize: 30 }} />
                </div>
                <h3 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", marginBottom: 10 }}>Access Denied</h3>
                <p style={{ fontSize: 14, color: "#64748b", lineHeight: 1.6, marginBottom: 0 }}>
                  You don't have access to this module. Please contact your administrator.
                </p>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <Footer />
    </div>
  );
};
